import * as Yup from 'yup';

export const FeedbackFormSchema = Yup.object().shape({
    feedback: Yup.string().required(),
    isPrivate: Yup.number(),
});
